import { Box, Button, TextField } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
function formatToDDMMYY(dateStr) {
  if (!dateStr) return "";
  if (dateStr.toString().includes("(")) return dateStr;
  const parts = dateStr.toString().split("-");
  const year = parts[0];
  const month = parts[1];
  const day = parts[2];
  const hr = parts[3];
  const formattedDate = `${day}-${month}-${year.slice(2)}`;
  return hr ? `${formattedDate}-${hr}` : formattedDate;
}
const EditRent = ({
  isEditingRent,
  roomIndex,
  setValue,
  // bookedRooms,
  dayRents,
  setRoomPriceDisable,
  onSave,
  onToggle,
}) => {
  const [data, setData] = useState([]);
  const [isChange, setisChange] = useState(false);
  const [applyDisable, setApplyDisable] = useState(false);
  const popupRef = useRef(null);

  // Simplified Smart Revert Logic
  const getComputedRateType = (newAmount, item) => {
    const userInput = Number(newAmount);
    const apiBase = Number(item.api_price);
    const apiWithChildren = Number(item.api_with_child_price);



    if (!apiBase && !apiWithChildren) {

      if (userInput === Number(item.original_base)) {
        return item.original_rate_type; 
      }
      return "edited";
    }

    if (userInput === apiBase) {

      return item.api_ratetype; 
    } else if (userInput === apiWithChildren) {

      return item.api_with_child_ratetype; 
    } else {

      return "edited"; 
    }
  };

  const dataLength = () => {
    let len = Object.keys(data).length;
    if (len < 4) return len * 40;
    else return 160;
  };

  // useEffect(() => {
  //   setData(bookedRooms?.day_rents || []);
  // }, [bookedRooms, roomIndex,bookedRooms.day_rents]);

  useEffect(() => {

    if (dayRents) {
      setData(dayRents);
      setisChange(false);
    }
  }, [dayRents]);

  useEffect(() => {
    const hasInvalid = data.some(item => !item.amount || Number(item.amount) === 0);
    setApplyDisable(hasInvalid);
  }, [data]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isEditingRent &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        !isChange
      ) {
        setValue(`booked_rooms.${roomIndex}.isEditingRent`, false);
        if (setRoomPriceDisable) setRoomPriceDisable(null);
        if (onToggle) onToggle();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditingRent, isChange, roomIndex]);

  const handleApplyAll = (index) => {
    setisChange(true);
    let firstDayRent = data[index]?.amount;
    if (firstDayRent !== "") {
      let tempData = data.map((item) => {
        const finalRateType = getComputedRateType(firstDayRent, item);
        return {
          ...item,
          amount: Number(firstDayRent),
          rate_type: finalRateType,
        };
      });
      setData(tempData);
    }
  };

  const modifyRent = () => {

    setValue(`booked_rooms.${roomIndex}.day_rents`, data); // update form state
    setValue(`booked_rooms.${roomIndex}.isEditingRent`, false);
    if (setRoomPriceDisable) setRoomPriceDisable(null);
    setisChange(false);
    if (onSave) onSave(data);
    if (onToggle) onToggle();
  };

  const handleChange = (index, value) => {
    setisChange(true);
    setData((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item;
        const newAmount = Number(value);
        const finalRateType = getComputedRateType(newAmount, item);

        return {
          ...item,
          amount: newAmount,
          rate_type: finalRateType,
        };
      }),
    );
  };

  const handleCancel = () => {
    // setData(bookedRooms[roomIndex]?.day_rents || []); // reset from form state
    setData(dayRents || []);
    setValue(`booked_rooms.${roomIndex}.isEditingRent`, false);
    if (setRoomPriceDisable) setRoomPriceDisable(null);
    setisChange(false);
    if (onToggle) onToggle();
  };

  if (!isEditingRent) return null;

  return (
    <Box
      ref={popupRef}
      position="absolute"
      sx={{
        width: "100%",
        height: "fit-content",
        backgroundColor: "transparent",
        zIndex: "100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "70%",
        padding: "1%",
        paddingTop: "1vh",
      }}
    // onClick={handleBackgroundClick}
    >
      <Box
        sx={{
          width: {
            sx: "90%",
            sm: "85%",
            md: "95%",
            lg: "80%",
          },
          zIndex: "100",

          "@media (max-width: 768px) and (pointer: coarse)": {
            display: "flex",
          },
          backgroundColor: "white",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          // border: "0.8px #FFC150 solid",
          borderRadius: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: "#F9F1DD",
            height: "50px",
            display: "flex",
            borderRadius: "8px 8px 0 0",
            fontWeight: "600",
            zIndex: "100",
            borderTop: "0.8px #FFC150 solid",
            borderLeft: "0.8px #FFC150 solid",
            borderRight: "0.8px #FFC150 solid",
          }}
        >
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              padding: "0 11%",
            }}
          >
            Date
          </Box>
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            Room Rent
          </Box>
        </Box>
        <Box
          sx={{
            maxHeight: "160px",
            overflowY: "auto",
            minHeight: `${dataLength()}px`,
            width: "100%",
            zIndex: "100",
            backgroundColor: "white !important",
            borderLeft: "0.8px #FFC150 solid",
            borderRight: "0.8px #FFC150 solid",

            pr: 1,
            pl: 1.5,
            scrollbarWidth: "thin", // Firefox
            scrollbarColor: "#ccc transparent", // Thumb and Track (Firefox)
            "@media (max-width: 768px) and (pointer: coarse)": {
              display: "block",
            },
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ccc", // light grey
              borderRadius: "8px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#bbb", // slightly darker on hover
            },
          }}
        >
          {data.map(({ date, grace_hours, amount }, index) => (
            <Box
              sx={{
                width: "100%",
                fontSize: "85%",
                backgroundColor: "#ffffff",
                height: "40px",
                display: "flex",
                borderRadius: index !== data.length - 1 ? "8px 8px 0 0" : "8px",
                borderBottom:
                  index !== data.length - 1 ? "1px solid #DFDFDF" : "none",
              }}
              key={date}
            >
              <Box
                sx={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  padding: "0 8%",
                }}
              >
                {grace_hours
                  ? isNaN(grace_hours)
                    ? grace_hours
                    : `${formatToDDMMYY(date.toString().split(" ")[0])}(${grace_hours}hr)`
                  : formatToDDMMYY(date.toString().split(" ")[0]).toString()}
              </Box>
              <Box
                sx={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "left",
                  position: "relative",
                }}
              >
                <TextField
                  size="small"
                  variant="standard"
                  value={amount == 0 ? " " : amount}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => {
                    const invalidChars = ["e", "E", "+", "-"];
                    if (invalidChars.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    width: "55%",
                    height: "70%",
                    "& .MuiInputBase-root": {
                      height: "100%",
                      border: "0.5px solid #FFE19A",
                      borderRadius: "4px",
                      padding: "0",
                    },
                    "& .MuiInput-underline:before, & .MuiInput-underline:after":
                    {
                      borderBottom: "none !important",
                    },
                    "& input": {
                      textAlign: "left",
                      padding: "4px 0 4px 13px !important",
                      fontSize: "65%",
                      lineHeight: "1.4",
                      appearance: "textfield",
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    },
                  }}
                  type="number"
                  inputProps={{
                    style: { MozAppearance: "textfield" },
                    step: "any",
                  }}
                />
                <Box
                  component="span"
                  sx={{
                    position: "absolute",
                    top: "52%",
                    transform: "translateY(-50%)",
                    left: "6px",
                    fontSize: "110%",
                    // top: "12px",
                  }}
                >
                  {" "}
                  ₹
                </Box>
                {amount !== "" && (
                  <Box
                    onClick={() => handleApplyAll(index)}
                    sx={{
                      flex: 1,
                      color: "#547AFF",
                      fontSize: "87%",
                      textDecoration: "underline",
                      cursor: "pointer",
                      textAlign: "center",
                    }}
                  >
                    Apply All
                  </Box>
                )}
              </Box>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "45px",
            display: "flex",
            borderRadius: "0 0 8px 8px",
            fontWeight: "600",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "40%",
            backgroundColor: "white !important",
            borderBottom: "0.8px #FFC150 solid",
            borderLeft: "0.8px #FFC150 solid",
            borderRight: "0.8px #FFC150 solid",
          }}
        >
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              zIndex: "100",
            }}
          >
            <Button
              variant="contained"
              onClick={modifyRent}
              disabled={applyDisable}
              sx={{
                width: "60%",
                height: "60%",
                display: "flex",
                alignItems: "center",
                // padding: '0 8%',
                justifyContent: "center",
                borderRadius: "4px",
                fontSize: "250%",
                marginLeft: "8%",
                cursor: "pointer",
                textTransform: "none",
              }}
            >
              Apply
            </Button>
          </Box>
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              onClick={handleCancel}
              component="button"
              sx={{
                width: "60%",
                height: "60%",
                display: "flex",
                alignItems: "center",
                padding: "0 1vw",
                justifyContent: "center",
                color: "#E7AC20",
                background: "white",
                border: "1.5px solid #E7AC20",
                borderRadius: "4px",
                fontSize: "250%",
                cursor: "pointer",
              }}
            >
              Cancel
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EditRent;
